import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrokerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		opacity: .1,
		width: 72,
		height: 72,
		rx: 6,
		fill: "#0E4EFB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M50 33V50H22V33L36 22.5L41.8 26.85L45 29.25L45.8 29.85L50 33Z",
		stroke: "#0E4EFB",
		strokeWidth: 4
	})]
});
export default SvgBrokerIcon;
